// import useGetProductInventoryTransition from '../hooks/useGetProductInventoryTransition'
import useStockStoreTypeContext from '../hooks/useStockStoreTypeContext'
import useBatchUpdateStock from '../hooks/useBatchUpdateStock'
import AuthComponent from '../../../components/AuthComponent'
import { Button, Space } from 'antd'
export default function ProductStockItemBtns({ record, freshList, setSkuId }) {
  const { isRealStock } = useStockStoreTypeContext()
  // const { openDetail } = useGetProductInventoryTransition()
  const { editStockBatch } = useBatchUpdateStock(freshList)
  return (
    <Space>
      <AuthComponent authKey='/inventory/stock/history'>
        <Button type='link' size='small' onClick={() => setSkuId(record.skuId)}>
          库存流水
        </Button>
      </AuthComponent>
      {!isRealStock && (
        <AuthComponent authKey='/inventory/stock/update'>
          <Button
            type='link'
            size='small'
            onClick={() => editStockBatch(record)}>
            修改销售库存
          </Button>
        </AuthComponent>
      )}
    </Space>
  )
}
